import styled from "@emotion/styled"

import { minTabletMediaQuery } from "theme/media-queries"

export const Container = styled.div`
  max-width: 1056px;
  margin: 0 auto;
  padding: 0px 16px 16px;
`

export const TotalNumberPostsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 60px 0;

  ${minTabletMediaQuery} {
    margin: 60px 0 70px;
  }
`

export const TotalNumberPosts = styled.span`
  ${p => p.theme.typography.special.size_36px.bold()}
  color: ${p => p.theme.colors.primaryMedium};
  margin: 0;

  ${minTabletMediaQuery} {
    ${p => p.theme.typography.special.size_40px.bold()}
  }
`

export const Line = styled.hr`
  border: 1.2px solid ${p => p.theme.colors.accentMedium};
  background-color: ${p => p.theme.colors.accentMedium};
  width: 88px;
  margin: 0 0 0 20px;

  ${minTabletMediaQuery} {
    width: 130px;
    margin: 0 0 0 30px;
  }
`
